import { ExperimentClient, IExperimentClientInitSettings, IFeatureFlag } from '@iamexperiences/client-experiment';
import { auth } from '../auth';
import { settingsManager } from '../shared/settings';
import { getTelemetry } from '../Telemetry/Telemetry';

const telemetry = getTelemetry();

// set namespace and remote url in configuration and get from there
const initSettings: IExperimentClientInitSettings = {
  remoteUrl: settingsManager.get('experimentRemoteUrl') ?? '',
  namespace: settingsManager.get('experimentNamespace') ?? '',
  onError: (name, error) => {
    telemetry.error(`Experiment Error ${name}: `, error);
  },
  getParams: () => {
    const map = new Map<string, string[]>();
    const tenantId = auth.user?.tenantId ?? '';
    const userId = auth.user?.objectId ?? '';
    map.set('tenantid', [tenantId]);
    map.set('userid', [userId]);
    return map;
  },
};

// You can set this default flags to configuration
const EXP_DEFAULT_FEATURE_FLAGS: IFeatureFlag = {
  sampleFeatureName: 'testTreatmentValue1',
  removeOfficeLinks: false,
};

export const experimentClient = new ExperimentClient({
  experimentFeatureFlags: EXP_DEFAULT_FEATURE_FLAGS,
  settings: initSettings,
});
